import { atom } from "recoil";

export const dashboardMyDeskTabIndexState = atom<number>({
  key: "dashboardMyDeskTabIndexState",
  default: 0,
});
